export const Keys = {
	TAB: 9,
	ENTER: 13,
	ESC: 27,
	UP: 38,
	DOWN: 40
};
